import type { IBookingOnboardingSubmission } from '@/_apis_/booking/type';
import { CommonTable } from '@/components/commonComponents/commonTable/commonTable';
import { ICommonTableHeadColumn } from '@/components/commonComponents/commonTable/commonTableHead/commonTableHead';
import Scrollbar from '@/components/Scrollbar';
import { Card } from '@mui/material';
import { BookingFormTableRow } from './BookingFormTableRow';

export interface BookingOnboardingTableItem {
    id: string;
    restaurantName: string;
    email: string;
    contact: string;
    ownerManagerName: string;
    diningDuration: string;
    bookingSlotInterval: string;
    minimumAdvanceBookingTime: string;
    sessionMaxCapacity: string;
    timezone: string;
    bookingType: string;
    maxPaxPerBooking: string;
    createdAt: number | null;
    createdAtDisplay: string;
    updatedAt: number | null;
    updatedAtDisplay: string;
    rawSubmission: IBookingOnboardingSubmission;
}

const createBookingFormsTableHead = (): ICommonTableHeadColumn<BookingOnboardingTableItem>[] => [
    { property: 'restaurantName', label: 'Restaurant', align: 'left' },
    { property: 'ownerManagerName', label: 'Owner / Manager', align: 'left' },
    { property: 'contact', label: 'Contact', align: 'left' },
    { property: 'email', label: 'Email', align: 'left' },
    { property: 'bookingType', label: 'Booking Type', align: 'left' },
    { property: 'createdAt', label: 'Created At', align: 'left' }
];

interface BookingFormsTableProps {
    submissionList: BookingOnboardingTableItem[];
    isLoading: boolean;
    customerHeader?: JSX.Element;
}

export const BookingFormsTable = ({ submissionList, isLoading, customerHeader }: BookingFormsTableProps): JSX.Element => {
    return (
        <Card>
            <Scrollbar>
                <CommonTable
                    columnList={createBookingFormsTableHead()}
                    dataList={submissionList}
                    isLoading={isLoading}
                    tableRowKey="id"
                    RowBodyComponent={BookingFormTableRow}
                    customerHeader={customerHeader}
                    rowsPerPageOptions={[10, 25, 50]}
                />
            </Scrollbar>
        </Card>
    );
};
